import React , { Component } from 'react'
import './index.css'

export default class ImgCodeInput extends Component{
    constructor(props) {
        super(props);
        this.state={
            showClear:false,
            value:''
        }
    }
    changeValue = (event) =>{
        const val = event.target.value
        if(val!==''){
            this.setState({showClear:true})
        }else{
            this.setState({showClear:false})
        }
        this.setState({value:val})
        this.props.changeCode && this.props.changeCode(val)
    }

    getValue = () =>{
        const {value} = this.state;
        return {value}
    }

    componentDidMount() {
        this.props.getValue && this.props.getValue(this)
    }

    changeCode = ()=>{
        let random=Math.ceil(Math.random()*10000);
        if(document.getElementsByClassName("sendImgCode").length>0){
            document.getElementsByClassName("sendImgCode")[0].childNodes[0].setAttribute('src',window.rootDirectroy + '/auth/checkCode/ver'+random)
        }
    }

    clearInputValue = (event) =>{
        event.target.previousSibling.value="";
        event.target.parentNode.classList.remove('phone');
        this.setState({showClear:false});
        this.props.changeCode && this.props.changeCode("");
    }
    render() {
        const {showClear} = this.state
        const {error} = this.props
        return (
            <div className="ImgCodeInput">
                <div className="ImgCodeBox">
                    <input className={error ? "error-input" : ""} onChange={this.changeValue} type="text" maxLength="4" placeholder={React.language('verification.img.code')}/>
                    {showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close"/>}
                </div>
                <div className="sendImgCode" onClick={this.changeCode}>
                    <img src={window.rootDirectroy + "/auth/checkCode"} alt=""/>
                </div>
            </div>
        );
    }
}